import { useState, useContext, useEffect, useRef } from "react";
import {
  FaCogs,
  FaEdit,
  FaGlobe,
  FaPlusCircle,
  FaTrashAlt,
  FaUpload,
  FaCalendarAlt,
  FaUser,
  FaBriefcase,
} from "react-icons/fa";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import Button from "components/ui/controls/button/button";
import Column from "components/ui/layout/column/column";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import Dialogs from "components/ui/dialogs/dialogs";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import RGProvider, { RGContext } from "components/app/AuditComplet/Retraite/Parametrage/ReleveRG/RGProvider";
import { CalculPrestationContrat, PdfReader } from "components/app/Api/Retraite/ApiRetraite";
import "components/app/styles/pageTitleStyles.css";
import Row from "components/ui/layout/row/row";
import RISProvider, { RISContext } from "components/app/AuditComplet/Retraite/RIS/RISProvider";
import { GetJsonAnalyseCarriere, ImportFichesPaie } from "components/app/Api/ApiSimulateur";
import "./parcours pro.css";

// Styles CSS pour l'animation
const styles = `
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-4px);
    }
    60% {
      transform: translateY(-2px);
    }
  }
  
  /* Style de scrollbar personnalisé pour Webkit */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
  
  /* Modale RIS alignée à gauche */
  .modal-ris-left {
    justify-content: flex-start !important;
    padding-left: 20px;
  }
`;

// Injection des styles
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}


// Period Card Component
const PeriodCard = ({ period, index, onEdit, onDelete, canDelete, correspondanceActivite }) => {
  const getActivityIcon = (nature) => {
    if (nature?.includes("Salarie") || nature?.includes("Fonction")) {
      return <FaBriefcase style={{ fontSize: 14, color: "#0d47a1" }} />;
    }
    return <FaUser style={{ fontSize: 14, color: "#0d47a1" }} />;
  };

  const getStatusType = (period) => {
    if (period.id === "CarriereActuelle") return "active";
    if (new Date(period.Fin) < new Date()) return "completed";
    return "pending";
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "12px 16px",
        marginBottom: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        transition: "all 0.2s ease",
        cursor: "pointer",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#e3f2fd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
          >
            {getActivityIcon(period.Nature)}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
              <h4
                style={{
                  margin: 0,
                  fontSize: "12px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                  fontWeight: 600,
                  color: "#333",
                  marginRight: "12px",
                }}
              >
                {correspondanceActivite[period.Nature] || "Activité non définie"}
              </h4>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "8px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  {applyFormat(period.Debut, "date", "")}
                </span>
              </div>
              <span style={{ color: "#ccc", fontSize: "10px" }}>→</span>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  {applyFormat(period.Fin, "date", "")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Button
            onClick={onEdit}
            icon
            style={{
              display: "inline-flex",
              padding: "8px",
              backgroundColor: "#f0fff4",
              border: "none",
              borderRadius: "6px",
            }}
          >
            <FaEdit style={{ color: "#22c55e" }} />
          </Button>
          {canDelete && (
            <Button
              onClick={onDelete}
              icon
              style={{
                display: "inline-flex",
                padding: "8px",
                backgroundColor: "#fff5f5",
                border: "none",
                borderRadius: "6px",
              }}
            >
              <FaTrashAlt style={{ color: "#f56565" }} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

const handleUploadRIS = (Infos) => (event) => {
  return PdfReader(event.target.files[0], Infos.IdUser, { Partner: Infos.Partner, IdPartner: Infos.IdPartner }).then((Res) => {
    if ("error" in Res || Res.data === "SizeError") {
      // setErrorMessage("Le logiciel n'a pas été en mesure de lire le relévé de carrière pour la raison suivante : Le fichier est un scan.");
      return [];
    } else if (Res.data[0] === "TechnicalError") {
      // setErrorMessage("Le logiciel n'a pas été en mesure de lire le relévé de carrière pour des raisons techniques.Votre RIS a été transmis à nos équipes.");
      return [];
    } else if (Res.data[0] === "FileError") {
      // setErrorMessage("Le logiciel n'a pas été en mesure de lire le relévé de carrière pour la raison suivante : fichier converti par l'application " + Res.data[1]["Software"] + ".");
      return [];
    } else {
      return GetJsonAnalyseCarriere(Res.data[1].RISInfos, "").then((InfosRIS) => {
        console.log("Parsed RIS Data:", InfosRIS);
        return InfosRIS.data || InfosRIS;
      });

      // ControlRIS(Res.data[1], Infos.IdUser, false, "").then((InfosRIS) => {
      //   setResults(Res.data[1]);
      //   setErrorMessage("");
      //   setSuccessMessage(true);
      //   handleGestionRIS(InfosRIS.data);
      // });
    }
  });
};
const ParcoursProPage = (props) => {
  const fileInputRef = useRef(null);
  const fichesPaieInputRef = useRef(null);
  const [periodesCarriere, setPeriodesCarriere] = useState([]);
  const [isUploadingFiches, setIsUploadingFiches] = useState(false);
  const handleFileUpload = () => {
    fileInputRef.current?.click();
  };
  
  const handleFichesPaieUpload = () => {
    fichesPaieInputRef.current?.click();
  };

  const handleFileChange = (evt) => {
    if (evt.target.files[0]) {
      handleUploadRIS(context.state)(evt)
        .then((data) => {
          console.log("RIS data received:", data);
          context.handleAddCorrectionCarriere({ data });
        })
        .catch((error) => {
          console.error("Error uploading RIS:", error);
          context.handleAddCorrectionCarriere({})
        });
    }
  };

  const handleFichesPaieChange = (evt) => {
    const files = evt.target.files;
    if (files && files.length > 0) {
      // Filtrer les fichiers pour ne garder que les formats acceptés
      const acceptedFormats = ['.pdf', '.jpg', '.jpeg', '.png'];
      const validFiles = Array.from(files).filter(file => {
        const extension = '.' + file.name.split('.').pop().toLowerCase();
        return acceptedFormats.includes(extension);
      });

      if (validFiles.length === 0) {
        Dialogs.Alert("Aucune fiche de paie valide trouvée dans le dossier. Formats acceptés : PDF, JPG, JPEG, PNG", "Erreur");
        evt.target.value = null;
        return;
      }

      console.log(`${validFiles.length} fichier(s) trouvé(s) dans le dossier`);
      setIsUploadingFiches(true);
      
      ImportFichesPaie(validFiles,"")
        .then((data) => {
          console.log("Fiches de paie analysées:", data);
          // Traiter les données retournées par l'IA
          // data devrait contenir: salaires, cotisations vieillesse, etc.
          if (data.success) {
            Dialogs.Alert(`${validFiles.length} fiche(s) de paie importée(s) avec succès!`, "Succès");
            // Mettre à jour le contexte avec les données extraites
            if (data.periodes) {
              context.handleAddCorrectionCarriere({ data: data.periodes });
            }
          } else {
            Dialogs.Alert(data.message || "Erreur lors de l'analyse des fiches de paie", "Erreur");
          }
        })
        .catch((error) => {
          console.error("Error uploading fiches de paie:", error);
          Dialogs.Alert("Erreur lors de l'import des fiches de paie", "Erreur");
        })
        .finally(() => {
          setIsUploadingFiches(false);
          // Réinitialiser l'input pour permettre de réimporter les mêmes fichiers
          evt.target.value = null;
        });
    }
  };

  const CorrespondanceActivite = {
    ActiviteSalarie: "Activité salariée",
    SalarieNonCadre: "Salarié non cadre du  secteur privé",
    SalarieCadre: "Salarié cadre du  secteur privé",
    SalarieNonCadreCFE: "Salarié non cadre cotisant CFE",
    SalarieCadreCFE: "Salarié cadre cotisant CFE",
    SalarieNonCadreAgricole: "Salarié non cadre du secteur agricole",
    SalarieCadreAgricole: "Salarié cadre du secteur agricole",
    SalarieIrcantec: "Salarié non titulaire de l'Etat",
    CavecSalarie: "Expert comptable salarié",
    CnbfSalarie: "Avocat salarié",
    FonctionPublique: "Fonction publique",
    Avpf: "Assurance vieillesse des parents au foyer",
    Chomage: "Chômage et assimilé",
    Maladie: "Maladie",
    Maternite: "Maternité",
    Invalidite: "Invalidité",
    Militaire: "Militaire, guerre",
    TrimSpecifique: "Trimestres spécifiques",
    RsiArtisan: "Artisan",
    Cnbf: "Avocat",
    Carpimko: "Auxiliaire médical",
    Carcdsf: "Chirurgien-dentiste",
    RsiCommercant: "Commerçant",
    MicroRSI: "Micro-entrepreneur ",
    MicroBIC: "Micro-entrepreneur ",
    MicroBNC: "Micro-entrepreneur ",
    MicroCipav: "Micro-entrepreneur ",
    Cavec: "Expert-comptable",
    Cavamac: "Agent général",
    Crn: "Notaire",
    Msa: "Exploitant agricole",
    Cipav: "Ingénieur conseil",
    Cavom: "Officier min., pub. ou judi.",
    Carmf: "Médecin",
    Cavp: "Pharmacien",
    Carcdsf2: "Sage-femme",
    Carpv: "Vétérinaire",
    Crpcen: "Clerc de notaire",
  };

  const context = useContext(AppContext);
  const [clientConjoint, setClientConjoint] = useState("");
  const [modalPeriodeRetr, setmodalPeriodeRetr] = useState(false);
  const [modalRISRetr, setmodalRISRetr] = useState(false);
  const [modalParamRetrOpen, setmodalParamRetrOpen] = useState(false);
  const ResultatTNS = useContext(RemExpertResultatTNS);

  useEffect(() => {
    if (context.state.ApiUser === true) {
      context.GetDateDepartRetraite("", context.state);
      context.GetDateDepartRetraite("Conjoint", context.state);
    }

    ResultatTNS.GetResultBilanRetraite(context.state, "").then((ResultatRetraite) => {
      context.state.ListeContrat.forEach((contratRetraite, index) => {
        CalculPrestationContrat(context.state, "", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
      });
    });
    if (context.state.InclureConjoint === true) {
      ResultatTNS.GetResultBilanRetraite(context.state, "Conjoint").then((ResultatRetraite) => {
        context.state.ListeContratConjoint.forEach((contratRetraite, index) => {
          CalculPrestationContrat(context.state, "Conjoint", ResultatRetraite, contratRetraite.Salaire, contratRetraite).then((Resultat) => {});
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ClientConjoint, context.state.AgeDepartProjection, context.state.AgeDepartProjectionConjoint, modalParamRetrOpen, modalPeriodeRetr]);

  useEffect(() => {
    if (props.ClientConjoint === "") {
      setClientConjoint("");
    } else {
      setClientConjoint("Conjoint");
    }
  }, [props.ClientConjoint]);

  return (
    <>
      <Column
        fill
        style={{
          minHeight: "100vh",
          backgroundColor: "#f8fafc",
          padding: "20px 0",
        }}
      >
        {/* Contenu principal */}
        <div style={{ padding: "0 20px" }}>
          {/* Boutons d'action modernisés - au-dessus des deux cartes */}
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
              <input ref={fileInputRef} type="file" style={{ display: "none" }} onChange={handleFileChange} accept=".pdf" />
              <input 
                ref={fichesPaieInputRef} 
                type="file" 
                webkitdirectory="" 
                directory="" 
                multiple 
                style={{ display: "none" }} 
                onChange={handleFichesPaieChange} 
              />
              <ActionButton
                onClick={handleFileUpload}
                icon={FaUpload}
                title="Importer le RIS"
                subtitle="Relevé tous régimes PDF"
                colors={{
                  primary: "rgb(124, 58, 237)",
                  secondary: "rgb(109, 40, 217)",
                  shadow: "rgba(124, 58, 237, 0.4)",
                  shadowHover: "rgba(124, 58, 237, 0.6)",
                  background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                }}
                decorativeIcon={{ type: "upload" }}
                style={{ width: "215px" }}
              />
              <ActionButton
                onClick={handleFichesPaieUpload}
                icon={FaUpload}
                title={isUploadingFiches ? "Import en cours..." : "Importer les fiches de paie"}
                subtitle="Sélectionnez un dossier"
                disabled={isUploadingFiches}
                colors={{
                  primary: "rgb(16, 185, 129)",
                  secondary: "rgb(5, 150, 105)",
                  shadow: "rgba(16, 185, 129, 0.4)",
                  shadowHover: "rgba(16, 185, 129, 0.6)",
                  background: "linear-gradient(135deg, rgb(16, 185, 129) 0%, rgb(5, 150, 105) 100%)",
                }}
                decorativeIcon={{ type: "document" }}
                style={{ width: "215px", opacity: isUploadingFiches ? 0.6 : 1 }}
              />
              <ActionButton
                onClick={() => {
                  context.handleResetPeriodeRetraite(clientConjoint, "");
                  setmodalPeriodeRetr(true);
                }}
                icon={FaPlusCircle}
                title="Ajouter une période"
                subtitle="Période projetée ou passée"
                colors={{
                  primary: "#11998e",
                  secondary: "#0d7377",
                  shadow: "rgba(17, 153, 142, 0.4)",
                  shadowHover: "rgba(17, 153, 142, 0.6)",
                }}
                decorativeIcon={{ type: "calendar" }}
                style={{ width: "215px" }}
              />
              <ActionButton
                onClick={() => {
                  setmodalParamRetrOpen(true);
                }}
                icon={FaCogs}
                title="Paramètres"
                subtitle="Configuration retraite"
                colors={{
                  primary: "#e57373",
                  secondary: "#c62828",
                  shadow: "rgba(229, 115, 115, 0.4)",
                  shadowHover: "rgba(229, 115, 115, 0.6)",
                }}
                decorativeIcon={{ type: "settings" }}
                style={{ width: "215px" }}
              />
            </div>
          </div>
          <Row tpad bpad>
            <div className="">
              <Column fill>
                <p className="card-description" style={{ marginTop: "16px" }}>
                  Historique de carrière:
                </p>

                {/* Cards en colonnes par année */}
                <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "16px" }}>
                  {context.state.CORRCARRAnalyseCarriere &&
                    context.state.CORRCARRAnalyseCarriere.map((data, index) => {
                      // Si l'année a une seule période
                      if (data.periodes && data.periodes.length === 1) {
                        const periode = data.periodes[0];
                        const hasTrimestres = data.trimestres && data.trimestres.length > 0 && data.trimestres.some((t) => t.valeur);
                        const hasPoints = data.points && data.points.length > 0 && data.points.some((p) => p.valeur);
                        const trimestresTotal = hasTrimestres ? data.trimestres.reduce((sum, t) => sum + (parseInt(t.valeur) || 0), 0) : 0;
                        const pointsTotal = hasPoints ? data.points.reduce((sum, p) => sum + (parseInt(p.valeur) || 0), 0) : 0;
                        const trimCaisse = hasTrimestres ? data.trimestres.find((t) => t.valeur)?.caisse : "";
                        const pointCaisse = hasPoints ? data.points.find((p) => p.valeur)?.caisse : "";
                        
                        // Détecter les problèmes
                        const hasActivityProblem = periode.employeur === "SANS ACTIVITÉ";
                        const hasTrimesterProblem = trimestresTotal !== 4;
                        const hasPointsProblem = !hasPoints || pointsTotal === 0;
                        
                        // Vérifier si le revenu est manquant et si c'est un problème
                        const activiteLowerCase = (periode.employeur || "").toLowerCase();
                        const isExemptActivity = activiteLowerCase.includes("chômage") || 
                                                 activiteLowerCase.includes("chomage") ||
                                                 activiteLowerCase.includes("maladie") || 
                                                 activiteLowerCase.includes("maternité") ||
                                                 activiteLowerCase.includes("maternite") ||
                                                 activiteLowerCase.includes("accident") || 
                                                 activiteLowerCase.includes("service national");
                        const isAssuranceRetraite = trimCaisse === "L'Assurance retraite";
                        const hasRevenuProblem = !periode.revenu && !isExemptActivity && isAssuranceRetraite;
                        
                        const hasProblems = hasActivityProblem || hasTrimesterProblem || hasPointsProblem || hasRevenuProblem;
                        const bandeauColor = hasProblems ? "#ef4444" : "#22c55e";

                        return (
                          <div key={"annee-" + index} className="card-box" style={{ display: "grid", gridTemplateColumns: "120px 130px 130px 180px 150px 120px 120px", gap: "10px",  }}>
                            <div
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                                borderLeft: `6px solid ${bandeauColor}`,
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p style={{ margin: "0 0 6px 0", color: "#6b7280", fontSize: "10px", fontWeight: "500" }}>Année</p>
                              <p style={{ margin: 0, color: "#1f2937", fontSize: "14px", fontWeight: "700" }}>{data.annee}</p>
                            </div>
                            <div
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p style={{ margin: "0 0 6px 0", color: "#6b7280", fontSize: "10px", fontWeight: "500" }}>Date début</p>
                              <p style={{ margin: 0, color: "#1f2937", fontSize: "13px", fontWeight: "600" }}>{periode.debut}</p>
                            </div>
                            <div
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p style={{ margin: "0 0 6px 0", color: "#6b7280", fontSize: "10px", fontWeight: "500" }}>Date fin</p>
                              <p style={{ margin: 0, color: "#1f2937", fontSize: "13px", fontWeight: "600" }}>{periode.fin}</p>
                            </div>
                            <div
                              style={{
                                backgroundColor: hasActivityProblem ? "#fecaca" : "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p style={{ margin: "0 0 6px 0", color: hasActivityProblem ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Activité</p>
                              <p style={{ margin: 0, color: hasActivityProblem ? "#ef4444" : "#1f2937", fontSize: "12px", fontWeight: "600" }}>{periode.employeur}</p>
                            </div>
                            <div
                              style={{
                                backgroundColor: hasRevenuProblem ? "#fecaca" : "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p style={{ margin: "0 0 6px 0", color: hasRevenuProblem ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Revenu</p>
                              <p style={{ margin: 0, color: hasRevenuProblem ? "#ef4444" : "#1f2937", fontSize: "13px", fontWeight: "600" }}>{periode.revenu || "-"}</p>
                            </div>
                            {hasTrimestres && (
                              <div
                                style={{
                                  backgroundColor: hasTrimesterProblem ? "#fecaca" : "#fff",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "6px",
                                  padding: "12px",
                                  textAlign: "center",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <p style={{ margin: "0 0 2px 0", color: hasTrimesterProblem ? "#ef4444" : "#6b7280", fontSize: "9px", fontWeight: "500" }}>{trimCaisse}</p>
                                <p style={{ margin: "0 0 4px 0", color: hasTrimesterProblem ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Trimestres</p>
                                <p style={{ margin: 0, color: hasTrimesterProblem ? "#ef4444" : "#1f2937", fontSize: "14px", fontWeight: "700" }}>{trimestresTotal}</p>
                              </div>
                            )}
                            <div
                              style={{
                                backgroundColor: hasPointsProblem ? "#fecaca" : "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <p style={{ margin: "0 0 2px 0", color: hasPointsProblem ? "#ef4444" : "#6b7280", fontSize: "9px", fontWeight: "500" }}>{pointCaisse || " "}</p>
                              <p style={{ margin: "0 0 4px 0", color: hasPointsProblem ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Points</p>
                              <p style={{ margin: 0, color: hasPointsProblem ? "#ef4444" : "#1f2937", fontSize: "16px", fontWeight: "700" }}>{hasPoints ? pointsTotal : "0"}</p>
                            </div>
                          </div>
                        );
                      }
                      // Si l'année a plusieurs périodes
                      else if (data.periodes && data.periodes.length > 1) {
                        const trimestresData = data.trimestres || [];
                        const pointsData = data.points || [];
                        
                        // Détecter les problèmes
                        const hasActivityProblem = data.periodes.some(p => p.employeur === "SANS ACTIVITÉ");
                        const trimestresTotal = trimestresData.reduce((sum, t) => sum + (parseInt(t.valeur) || 0), 0);
                        const hasTrimesterProblem = trimestresTotal !== 4;
                        const pointsTotal = pointsData.reduce((sum, p) => sum + (parseInt(p.valeur) || 0), 0);
                        const hasPointsProblem = pointsData.length === 0 || pointsTotal === 0;
                        
                        // Vérifier si un revenu est manquant pour les périodes non exemptées
                        const hasRevenuProblem = data.periodes.some((p, idx) => {
                          const activiteLowerCase = (p.employeur || "").toLowerCase();
                          const isExemptActivity = activiteLowerCase.includes("chômage") || 
                                                   activiteLowerCase.includes("chomage") ||
                                                   activiteLowerCase.includes("maladie") || 
                                                   activiteLowerCase.includes("maternité") ||
                                                   activiteLowerCase.includes("maternite") ||
                                                   activiteLowerCase.includes("accident") || 
                                                   activiteLowerCase.includes("service national");
                          const isAssuranceRetraite = p.regimes && p.regimes.includes("L'Assurance retraite");
                          return !p.revenu && !isExemptActivity && isAssuranceRetraite;
                        });
                        
                        const hasProblems = hasActivityProblem || hasTrimesterProblem || hasPointsProblem || hasRevenuProblem;
                        const bandeauColor = hasProblems ? "#ef4444" : "#22c55e";

                        // Regrouper les trimestres par type unique (caisse + valeur) en ignorant les vides
                        const trimestresTypes = new Map();
                        data.periodes.forEach((periode, pIndex) => {
                          const trimestre = trimestresData[pIndex];
                          if (trimestre && trimestre.valeur) {
                            const trimestreKey = `${trimestre.caisse}-${trimestre.valeur}`;
                            if (!trimestresTypes.has(trimestreKey)) {
                              trimestresTypes.set(trimestreKey, {
                                key: trimestreKey,
                                caisse: trimestre.caisse,
                                valeur: parseInt(trimestre.valeur),
                              });
                            }
                          }
                        });

                        // Si un seul type de trimestre, créer une carte sur toute la hauteur
                        const trimestresGroups =
                          trimestresTypes.size === 1
                            ? [{ ...Array.from(trimestresTypes.values())[0], startRow: 1, endRow: data.periodes.length + 1 }]
                            : trimestresTypes.size === 0
                            ? [{ key: "empty", startRow: 1, endRow: data.periodes.length + 1, valeur: null }]
                            : (() => {
                                // Répartir équitablement la hauteur entre les groupes
                                const groupsArray = Array.from(trimestresTypes.values());
                                const totalRows = data.periodes.length;
                                const rowsPerGroup = totalRows / groupsArray.length;

                                return groupsArray.map((group, idx) => ({
                                  ...group,
                                  startRow: Math.round(idx * rowsPerGroup) + 1,
                                  endRow: Math.round((idx + 1) * rowsPerGroup) + 1,
                                }));
                              })();

                        // Regrouper les points par type unique (caisse + valeur) en ignorant les vides
                        const pointsTypes = new Map();
                        data.periodes.forEach((periode, pIndex) => {
                          const point = pointsData[pIndex];
                          if (point && point.valeur) {
                            const pointKey = `${point.caisse}-${point.valeur}`;
                            if (!pointsTypes.has(pointKey)) {
                              pointsTypes.set(pointKey, {
                                key: pointKey,
                                caisse: point.caisse,
                                valeur: parseInt(point.valeur),
                              });
                            }
                          }
                        });

                        // Si un seul type de point, créer une carte sur toute la hauteur
                        const pointsGroups =
                          pointsTypes.size === 1
                            ? [{ ...Array.from(pointsTypes.values())[0], startRow: 1, endRow: data.periodes.length + 1 }]
                            : pointsTypes.size === 0
                            ? [{ key: "empty", startRow: 1, endRow: data.periodes.length + 1, valeur: 0 }]
                            : (() => {
                                // Répartir équitablement la hauteur entre les groupes
                                const groupsArray = Array.from(pointsTypes.values());
                                const totalRows = data.periodes.length;
                                const rowsPerGroup = totalRows / groupsArray.length;

                                return groupsArray.map((group, idx) => ({
                                  ...group,
                                  startRow: Math.round(idx * rowsPerGroup) + 1,
                                  endRow: Math.round((idx + 1) * rowsPerGroup) + 1,
                                }));
                              })();

                        return (
                          <div
                            key={"annee-" + index}
                            className="card-box"
                            style={{ display: "grid", gridTemplateColumns: "120px 130px 130px 180px 150px 120px 120px", gap: "10px", gridAutoRows: "minmax(70px, 1fr)" }}
                          >
                            {/* Card Année - s'étend sur toutes les lignes */}
                            <div
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                                borderLeft: `6px solid ${bandeauColor}`,
                                borderRadius: "6px",
                                padding: "12px",
                                textAlign: "center",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                gridRow: `1 / span ${data.periodes.length}`,
                                gridColumn: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div>
                                <p style={{ margin: "0 0 6px 0", color: "#6b7280", fontSize: "10px", fontWeight: "500" }}>Année</p>
                                <p style={{ margin: 0, color: "#1f2937", fontSize: "14px", fontWeight: "700" }}>{data.annee}</p>
                              </div>
                            </div>

                            {/* Cards Trimestres groupées */}
                            {trimestresGroups.map((group, gIndex) =>
                              group.valeur !== null ? (
                                <div
                                  key={`trimestres-group-${gIndex}`}
                                  style={{
                                    backgroundColor: hasTrimesterProblem ? "#fecaca" : "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridRow: `${group.startRow} / ${group.endRow}`,
                                    gridColumn: "6",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 2px 0", color: hasTrimesterProblem ? "#ef4444" : "#6b7280", fontSize: "9px", fontWeight: "500" }}>{group.caisse}</p>
                                  <p style={{ margin: "0 0 4px 0", color: hasTrimesterProblem ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Trimestres</p>
                                  <p style={{ margin: 0, color: hasTrimesterProblem ? "#ef4444" : "#1f2937", fontSize: "14px", fontWeight: "700" }}>{group.valeur}</p>
                                </div>
                              ) : (
                                <div
                                  key={`trimestres-empty-${gIndex}`}
                                  style={{
                                    backgroundColor: "#f9fafb",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridRow: `${group.startRow} / ${group.endRow}`,
                                    gridColumn: "6",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: 0, color: "#d1d5db", fontSize: "10px", fontWeight: "500" }}>-</p>
                                </div>
                              )
                            )}

                            {/* Cards Points groupées */}
                            {pointsGroups.map((group, gIndex) =>
                              group.valeur !== null && group.valeur !== 0 ? (
                                <div
                                  key={`points-group-${gIndex}`}
                                  style={{
                                    backgroundColor: hasPointsProblem ? "#fecaca" : "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridRow: `${group.startRow} / ${group.endRow}`,
                                    gridColumn: "7",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 2px 0", color: hasPointsProblem ? "#ef4444" : "#6b7280", fontSize: "9px", fontWeight: "500" }}>{group.caisse}</p>
                                  <p style={{ margin: "0 0 4px 0", color: hasPointsProblem ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Points</p>
                                  <p style={{ margin: 0, color: hasPointsProblem ? "#ef4444" : "#1f2937", fontSize: "16px", fontWeight: "700" }}>{group.valeur}</p>
                                </div>
                              ) : (
                                <div
                                  key={`points-empty-${gIndex}`}
                                  style={{
                                    backgroundColor: "#fecaca",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridRow: `${group.startRow} / ${group.endRow}`,
                                    gridColumn: "7",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 2px 0", color: "#ef4444", fontSize: "9px", fontWeight: "500" }}> </p>
                                  <p style={{ margin: "0 0 4px 0", color: "#ef4444", fontSize: "10px", fontWeight: "500" }}>Points</p>
                                  <p style={{ margin: 0, color: "#ef4444", fontSize: "16px", fontWeight: "700" }}>-</p>
                                </div>
                              )
                            )}

                            {/* Lignes pour chaque période */}
                            {data.periodes.map((periode, pIndex) => (
                              <>
                                <div
                                  key={`debut-${pIndex}`}
                                  style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridColumn: "2",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 6px 0", color: "#6b7280", fontSize: "10px", fontWeight: "500" }}>Date début</p>
                                  <p style={{ margin: 0, color: "#1f2937", fontSize: "13px", fontWeight: "600" }}>{periode.debut || "-"}</p>
                                </div>
                                <div
                                  key={`fin-${pIndex}`}
                                  style={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridColumn: "3",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 6px 0", color: "#6b7280", fontSize: "10px", fontWeight: "500" }}>Date fin</p>
                                  <p style={{ margin: 0, color: "#1f2937", fontSize: "13px", fontWeight: "600" }}>{periode.fin || "-"}</p>
                                </div>
                                <div
                                  key={`activite-${pIndex}`}
                                  style={{
                                    backgroundColor: periode.employeur === "SANS ACTIVITÉ" ? "#fecaca" : "#fff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridColumn: "4",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 6px 0", color: periode.employeur === "SANS ACTIVITÉ" ? "#ef4444" : "#6b7280", fontSize: "10px", fontWeight: "500" }}>Activité</p>
                                  <p style={{ margin: 0, color: periode.employeur === "SANS ACTIVITÉ" ? "#ef4444" : "#1f2937", fontSize: "12px", fontWeight: "600" }}>{periode.employeur || "-"}</p>
                                </div>
                                <div
                                  key={`revenu-${pIndex}`}
                                  style={{
                                    backgroundColor: (() => {
                                      const activiteLowerCase = (periode.employeur || "").toLowerCase();
                                      const isExemptActivity = activiteLowerCase.includes("chômage") || 
                                                               activiteLowerCase.includes("chomage") ||
                                                               activiteLowerCase.includes("maladie") || 
                                                               activiteLowerCase.includes("maternité") ||
                                                               activiteLowerCase.includes("maternite") ||
                                                               activiteLowerCase.includes("accident") || 
                                                               activiteLowerCase.includes("service national");
                                      const isAssuranceRetraite = periode.regimes && periode.regimes.includes("L'Assurance retraite");
                                      const hasRevenuProblemHere = !periode.revenu && !isExemptActivity && isAssuranceRetraite;
                                      return hasRevenuProblemHere ? "#fecaca" : "#fff";
                                    })(),
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "6px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    gridColumn: "5",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p style={{ margin: "0 0 6px 0", color: (() => {
                                      const activiteLowerCase = (periode.employeur || "").toLowerCase();
                                      const isExemptActivity = activiteLowerCase.includes("chômage") || 
                                                               activiteLowerCase.includes("chomage") ||
                                                               activiteLowerCase.includes("maladie") || 
                                                               activiteLowerCase.includes("maternité") ||
                                                               activiteLowerCase.includes("maternite") ||
                                                               activiteLowerCase.includes("accident") || 
                                                               activiteLowerCase.includes("service national");
                                      const isAssuranceRetraite = periode.regimes && periode.regimes.includes("L'Assurance retraite");
                                      const hasRevenuProblemHere = !periode.revenu && !isExemptActivity && isAssuranceRetraite;
                                      return hasRevenuProblemHere ? "#ef4444" : "#6b7280";
                                    })(), fontSize: "10px", fontWeight: "500" }}>Revenu</p>
                                  <p style={{ margin: 0, color: (() => {
                                      const activiteLowerCase = (periode.employeur || "").toLowerCase();
                                      const isExemptActivity = activiteLowerCase.includes("chômage") || 
                                                               activiteLowerCase.includes("chomage") ||
                                                               activiteLowerCase.includes("maladie") || 
                                                               activiteLowerCase.includes("maternité") ||
                                                               activiteLowerCase.includes("maternite") ||
                                                               activiteLowerCase.includes("accident") || 
                                                               activiteLowerCase.includes("service national");
                                      const isAssuranceRetraite = periode.regimes && periode.regimes.includes("L'Assurance retraite");
                                      const hasRevenuProblemHere = !periode.revenu && !isExemptActivity && isAssuranceRetraite;
                                      return hasRevenuProblemHere ? "#ef4444" : "#1f2937";
                                    })(), fontSize: "13px", fontWeight: "600" }}>{periode.revenu || "-"}</p>
                                </div>
                              </>
                            ))}
                          </div>
                        );
                      }
                      return null;
                    })}
                </div>
              </Column>
            </div>
          </Row>
          <div style={{ display: "flex", gap: 24, alignItems: "stretch", height: "613px" }}>
            <div style={{ flex: 1, minWidth: 0, position: "relative", display: "flex" }}>
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "24px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                    paddingBottom: "16px",
                    borderBottom: "2px solid #f0f0f0",
                  }}
                >
                  <div>
                    <h3
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#333",
                        marginBottom: "4px",
                      }}
                    >
                      Périodes de carrière
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      Historique des activités professionnelles
                    </p>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        backgroundColor: "#f8f9fa",
                        padding: "6px 12px",
                        borderRadius: "20px",
                      }}
                    >
                      {context.state["Carriere" + clientConjoint]?.length} période(s)
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    overflow: "auto",
                    flex: 1,
                    scrollbarWidth: "thin",
                    scrollbarColor: "#cbd5e1 #f1f5f9",
                    paddingRight: "12px",
                    marginRight: "4px",
                  }}
                  className="custom-scrollbar"
                >
                  {context.state["Carriere" + clientConjoint]?.map((Infos, Index) => (
                    <PeriodCard
                      key={Index}
                      period={Infos}
                      index={Index}
                      correspondanceActivite={CorrespondanceActivite}
                      onEdit={() => {
                        context.handleModifyDeletePeriodeRetraite(Infos.id, "Modifier", "", clientConjoint);
                        setmodalPeriodeRetr(true);
                      }}
                      onDelete={() => {
                        Dialogs.confirm("Vous êtes sur le point de supprimer la période.\nVoulez-vous continuer ?", "Suppression de la période", () => {
                          context.handleModifyDeletePeriodeRetraite(Infos.id, "Supprimer", "", clientConjoint);
                        });
                      }}
                      canDelete={Infos.id !== "CarriereActuelle"}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Column>
      <Modal
        width="75%"
        height="82%"
        title="Ajouter une période"
        icon={<FaGlobe />}
        visible={modalPeriodeRetr}
        onClose={() => {
          setmodalPeriodeRetr(false);
        }}
        className="modal-ris-left"
      >
        {/* <AjoutPeriodePageModal
          Outil=""
          ClientConjoint={clientConjoint}
          visible={modalPeriodeRetr}
          onClose={() => {
            setmodalPeriodeRetr(false);
          }}
        /> */}
      </Modal>
      <Modal width="75%" height="82%" title="Lecture du relevé de carrière" icon={<FaGlobe />} visible={modalRISRetr} onClose={() => {}} className="modal-ris-left">
        {/* <AjoutRISPageModal
          Outil=""
          ClientConjoint={clientConjoint}
          visible={modalRISRetr}
          onClose={() => {
            setmodalRISRetr(false);
          }}
          onRISEvent={(action) => {
          }}
        /> */}
      </Modal>
      <RGProvider ClientConjoint={clientConjoint} visible={modalParamRetrOpen}>
        <RGContext.Consumer>
          {(RGCtx) => (
            <Modal
              width="75%"
              height="92%"
              title="Paramétrage de la retraite"
              icon={<FaGlobe />}
              visible={modalParamRetrOpen}
              onClose={() => {
                setmodalParamRetrOpen(false);
              }}
              className="modal-ris-left"
            >
              {/* <ParamRetraitePageModal
                Outil=""
                ClientConjoint={clientConjoint}
                visible={modalParamRetrOpen}
                onClose={() => {
                  setmodalParamRetrOpen(false);
                }}
              /> */}
            </Modal>
          )}
        </RGContext.Consumer>
      </RGProvider>
    </>
  );
};

const ParcoursProPageWithProvider = (props) => {
  return (
    <RISProvider visible={true}>
      <ParcoursProPage {...props} />
    </RISProvider>
  );
};

export default ParcoursProPageWithProvider;
